<template>
    <diaLog tit="提现审核" ref="dialog" width="500px" @handleBtn="handleBtn" @handleClose="handleClose">
        <div class="settlementBox">
            <div class="settlementItem">
                <div class="tit">累计收益（元）</div>
                <div>{{moneyDetails.allEarningsAmount}}</div>
            </div>
            <div class="settlementItem">
                <div class="tit">已提现（元）</div>
                <div>{{moneyDetails.withdrawAmount}}</div>
            </div>
            <div class="settlementItem">
                <div class="tit">待结算（元）</div>
                <div>{{moneyDetails.waitSettlementAmount}}</div>
            </div>
            <div class="settlementItem">
                <div class="tit">可提现（元）</div>
                <div>{{moneyDetails.allowWithdrawAmount}}</div>
            </div>
        </div>
        <p>该用户当前申请的提现金额为{{num}}元，小于等于当前可提现金额，请确认是否通过该账号提现审核？</p>
    </diaLog>
</template>

<script>
import diaLog from '@/components/diaLog'
export default {
    components: { diaLog },
    props: {
        moneyDetails: {
            type: Object,
            default: () => {
                return {
                    allEarningsAmount: 0,
                    withdrawAmount: 0,
                    waitSettlementAmount: 0,
                    allowWithdrawAmount: 0,
                }
            }
        },
        num: [String, Number]
    },
    methods: {
        handleBtn() {
            console.log(13123)
            this.$emit('settlementBtn')
        },
        handleClose() {
            this.$emit('settlementClose')
        }
    },
}
</script>

<style lang="scss" scoped>
.settlementBox{
    overflow: hidden;
    .settlementItem{
        width: 50%;
        float: left;
        text-align: center;
        margin-bottom: 30px;
    }
    .tit{
        margin-bottom: 5px;
        font-weight: bold;
    }
}
</style>
